var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.empty)?_c('div',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.t('No records found.'))+" ")]):_c('div',[_c('Chart',{attrs:{"chartdata":_vm.chartdata,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }